/**
 * Utilitários para manipulação de cores
 */

/**
 * Converte cor hexadecimal para rgba com transparência
 * @param hex - Cor hexadecimal (#RRGGBB)
 * @param alpha - Transparência (0-1)
 * @returns String rgba
 * 
 * @example
 * hexToRgba("#053238", 0.5)
 * // Retorna: "rgba(5, 50, 56, 0.5)"
 */
export const hexToRgba = (hex: string, alpha: number): string => {
  const normalized = hex.replace("#", "");
  
  if (normalized.length !== 6) {
    console.warn(`hexToRgba: formato inválido "${hex}", retornando original`);
    return hex;
  }
  
  const bigint = parseInt(normalized, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/**
 * Ajusta opacidade de uma cor (hex ou rgba)
 * @param color - Cor em hex ou rgba
 * @param opacity - Nova opacidade (0-1)
 * @returns String rgba
 * 
 * @example
 * adjustOpacity("rgba(5, 50, 56, 0.8)", 0.5)
 * // Retorna: "rgba(5, 50, 56, 0.5)"
 * 
 * adjustOpacity("#053238", 0.3)
 * // Retorna: "rgba(5, 50, 56, 0.3)"
 */
export const adjustOpacity = (color: string, opacity: number): string => {
  // Se já for rgba, substituir alpha
  if (color.startsWith("rgba")) {
    return color.replace(/[\d.]+\)$/g, `${opacity})`);
  }
  
  // Se for hex, converter
  return hexToRgba(color, opacity);
};
